module.exports = __webpack_public_path__ + "static/media/maghrib.c3c70909.png";